import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from '@components/atoms/Popup';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Button, ButtonMode } from '@components/atoms/Button';
import styles from './PopupDelete.module.css';

export interface PopupDeleteProps {
    id?: string;
    question: string;
    confirmation: string;
    warning: string;
    confirmButtonText?: string;
    onClickConfirm: () => void;
    disabled?: boolean;
    show: boolean;
    onHide: () => void;
}

export const PopupDelete: FC<PopupDeleteProps> = ({
    id,
    question,
    confirmation,
    warning,
    confirmButtonText,
    onClickConfirm,
    disabled,
    show,
    onHide,
}) => {
    const { t } = useTranslation();

    const translations = {
        cancel: t('popup-delete-component.cancel.button'),
        confirm: t('popup-delete-component.confirm.button'),
    };

    return (
        <Popup id={id || undefined} show={show} onHide={onHide} desktopWidth="400px">
            <div className={`${styles.content} d-flex flex-column gap-3`}>
                <div className={`${styles['modal-icon']} ${styles['modal-icon-danger']}`}>
                    <div className={`d-flex flex-column justify-content-center text-center ${styles['rounded-circle']}`}>
                        <i className="fa-thin fa-trash-can" aria-hidden="true" />
                    </div>
                </div>
                <Typography tagVariant={TypographyTagVariants.p} classes="mb-0" fontSize="20" fontWeight="900">
                    {question}
                </Typography>
                <Typography tagVariant={TypographyTagVariants.p} classes="mb-0" fontSize="16">
                    {confirmation}
                </Typography>
                <Typography tagVariant={TypographyTagVariants.p} classes="mb-0" fontSize="12" fontWeight="800" color="danger">
                    {warning}
                </Typography>
                <div className="d-flex gap-4 mt-3">
                    <div>
                        <Button
                            label={translations.cancel}
                            mode={ButtonMode.danger}
                            classes="w-100"
                            onClick={onHide}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <Button
                            label={confirmButtonText || translations.confirm}
                            mode={ButtonMode.primary}
                            classes="w-100"
                            onClick={onClickConfirm}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        </Popup>
    );
};
